export class CommRate {


}

export module CommRate {
  export enum RuleType {
    AMOUNTPERLOT="AMOUNTPERLOT",
    AMOUNTPERLOT_STRATEGY="AMOUNTPERLOT_STRATEGY",
    AMOUNTPERLOT_AND_CTRSIZE="AMOUNTPERLOT_AND_CTRSIZE",
    NONE="NONE"
  }
}
